import { DynamicFormV2Palette } from "@mui/material";

export type FormThermometerComponentTokenType = {
  backgroundColor: string;
  textColor: string;
  progressTrackBackgroundColor: string;
  progressBarBackgroundColor: string;
  heartsColor: string;
};

export const assignThermometerComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark"
) => {
  const isLightMode = mode === "light";

  return {
    backgroundColor: isLightMode ? formsPalette.surface.quiet : formsPalette.surface.supershy,
    textColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.intense,
    progressTrackBackgroundColor: formsPalette.surface.moderate,
    progressBarBackgroundColor: isLightMode ? formsPalette.surface.intense : formsPalette.surface.reverse,
    heartsColor: formsPalette.surface.moderate,
  } as FormThermometerComponentTokenType;
};
